<template>
	<RectangleTile @click="tileClicked()" v-interact class="background-tile-primary">



		<template v-slot:badge>
			<TileBadge :name="badgeName"></TileBadge>
		</template>




		<template v-slot:icon>
			<TileIcon :imageName="image"></TileIcon>
		</template>





		<template v-slot:details>
			<TileDetails>
				<template v-slot:name>{{ name }}</template>
				<template v-slot:description>{{ task.description }}</template>
			</TileDetails>
		</template>



		<template v-slot:actions>
			<TileCoins :coins_amount="task.coins_amount" />
		</template>





	</RectangleTile>
</template>



<script>

import { computed } from "vue";
import { UserActivityStore } from "@/store/UserActivityStore";

import { InHouseTaskMapping } from "@/constants/InHouseTaskMapping";

import TileIcon from "@/components/Common/Tile-Icon.vue";
import TileBadge from '@/components/Common/Tile-Badge.vue';
import TileDetails from "@/components/Common/Tile-Details.vue";
import TileCoins from "@/components/Common/Tile-Coins.vue";
import RectangleTile from '@/components/Tiles/Rectangle-Tile.vue';


function getMappingValue(name, key) {
	return InHouseTaskMapping[name]?.[key] || "";
}



export default {
	name: "InHouseTaskRectangleTile",
	components: {
		TileIcon,
		TileBadge,
		TileDetails,
		TileCoins,
		RectangleTile,
	},
	props: {
		name: String,
	},
	setup(props) {
		const inHouseTasksStore = UserActivityStore();
		const task = computed(() => inHouseTasksStore.inHouseTasks[props.name]);

		return {
			task,
			inHouseTasksStore
		};


	},
	computed: {
		image() {
			return getMappingValue(this.name, "image");
		},
		badgeName() {
			return getMappingValue(this.name, "badgeName");
		},
	},
	methods: {
		tileClicked() {
			this.inHouseTasksStore.selectInHouseTaskByName(this.name);
		},
	},
};

</script>
